// Яндекс Метрика и отказ от неё. С 06.10.2026 счётчик грузится сразу, а
// плашка и галочка в настройках дают его отключить (решение владельца: при
// схеме "только после Разрешить" Метрика не видела ни одного перехода с
// рекламы в Директе). Политики /legal/cookies и /legal/privacy описывают
// именно эту схему. Отказались или нет номера счётчика, значит Метрики нет.
//
// Выбор хранится на устройстве (localStorage), как и отметка о плашке: вход
// в аккаунт тут не нужен, счётчик работает и на лендинге. localStorage может
// быть недоступен — тогда выбор живёт до перезагрузки, плашка спросит снова.

// Номер счётчика из metrika.yandex.ru. Он публичный (виден в коде любой
// страницы со счётчиком), поэтому лежит здесь, а не в переменных окружения.
// null — Метрика выключена, плашка показывает прежний текст без выбора.
export const YM_COUNTER_ID: number | null = 113108385

export type AnalyticsChoice = 'granted' | 'denied'

const STORAGE_KEY = 'tk-analytics'
const listeners = new Set<() => void>()
let inMemory: AnalyticsChoice | null = null

export function subscribeAnalytics(cb: () => void) {
  listeners.add(cb)
  return () => {
    listeners.delete(cb)
  }
}

export function getAnalyticsChoice(): AnalyticsChoice | null {
  if (inMemory) return inMemory
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    return v === 'granted' || v === 'denied' ? v : null
  } catch {
    return null
  }
}

// Метрика работает, пока от неё явно не отказались.
export function isAnalyticsOn(): boolean {
  return getAnalyticsChoice() !== 'denied'
}

export function setAnalyticsChoice(choice: AnalyticsChoice) {
  const was = getAnalyticsChoice()
  inMemory = choice
  try {
    localStorage.setItem(STORAGE_KEY, choice)
  } catch {
    // не сохранилось — действует до перезагрузки
  }
  listeners.forEach((l) => l())
  // Отключили, а счётчик уже загружен на странице: выгрузить скрипт нельзя,
  // поэтому стираем его cookie и данные и перезагружаем страницу.
  if (was !== 'denied' && choice === 'denied' && window.ym) {
    clearMetrikaTraces()
    window.location.reload()
  }
}

// Метрика пишет cookie на домен второго уровня (.turkido.ru), поэтому удаляем
// и с доменом, и без него: какой вариант совпадёт, тот и сотрёт.
function clearMetrikaTraces() {
  const host = window.location.hostname
  const parts = host.split('.')
  const domains = ['', host, parts.length > 1 ? '.' + parts.slice(-2).join('.') : '']
  for (const pair of document.cookie.split(';')) {
    const name = pair.split('=')[0].trim()
    if (!name.startsWith('_ym')) continue
    for (const d of domains) {
      document.cookie = `${name}=; Max-Age=0; path=/${d ? `; domain=${d}` : ''}`
    }
  }
  try {
    for (const k of Object.keys(localStorage)) if (k.startsWith('_ym')) localStorage.removeItem(k)
  } catch {
    // нет доступа — нечего и чистить
  }
}

// Цель Метрики (события чек-листа и подсказок новичкам, тикет 91). Молча
// ничего не делает, если Метрики нет или от неё отказались.
export function reachGoal(goal: string, params?: Record<string, string | number>) {
  if (typeof window === 'undefined' || !YM_COUNTER_ID || !isAnalyticsOn()) return
  window.ym?.(YM_COUNTER_ID, 'reachGoal', goal, params)
}
